//Note: The main reason this function was created was that the Map.prototype.forEach function.
//Note: For some reason reverse its parameters, which is very misleading and may result in mistakes.
export default function(map, callback) {
    return map.forEach((value, key) => {
        //Also we ignore the map itself, cause obviously its redundant!
        //May be we can consider ignoring the Map.prototype.forEach implementation as it does not
        //implement index and index might be needed by the consumer callback...
        callback(key, value);
    });
}
